export const DAYS_OF_WEEK = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'] as const;

export const HOURS_IN_DAY = Array.from({ length: 24 }, (_, i) => i);

export const BOOKING_BUFFER_HOURS = 48;

export const WORK_HOURS_START = 6;
export const WORK_HOURS_END = 22;

export const SLOT_COLORS = {
  available: 'bg-(--primary-O200) border-(--primary-O700)',
  booked: 'bg-(--secondary-B100) border-(--secondary-B800)',
  pending: 'bg-(--warning-W100) border-(--warning-W700)',
  rejected: 'bg-(--danger-D100) border-(--danger-D700)',
  past: 'bg-(--neutral-black-NB100) border-(--neutral-black-NB200)',
  selected: 'bg-(--tertiary-Y100) border-(--tertiary-Y400)',
} as const;

export const SLOT_HOVER_COLORS = {
  available: 'hover:bg-(--danger-D300) hover:border-(--danger-D700)',
} as const;

export const DAYS_OF_WEEK_WITH_VALUES = [
  { value: 1, label: 'Mon' },
  { value: 2, label: 'Tue' },
  { value: 3, label: 'Wed' },
  { value: 4, label: 'Thu' },
  { value: 5, label: 'Fri' },
  { value: 6, label: 'Sat' },
  { value: 0, label: 'Sun' },
] as const;

export const DEFAULT_START_TIME = '09:00';
export const DEFAULT_END_TIME = '17:00';
export const DEFAULT_WEEKDAYS = [1, 2, 3, 4, 5]; // Monday to Friday

export const LOCALE = 'en-US';
export const HOUR_INCREMENT = 1;
export const DAY_INCREMENT = 1;
export const FIRST_HOUR = 0;
export const LAST_HOUR = 23;
export const SUNDAY = 0;
export const DAYS_BEFORE_SUNDAY = -6;
export const MONDAY = 1;
export const LAST_DAY_OF_WEEK = 6;
export const END_OF_DAY_HOUR = 23;
export const END_OF_DAY_MINUTE = 59;
export const END_OF_DAY_SECOND = 59;
export const END_OF_DAY_MILLISECOND = 999;
export const ZERO_MINUTES = 0;
export const ZERO_SECONDS = 0;
export const ZERO_MILLISECONDS = 0;
export const PAD_LENGTH = 2;
export const PAD_CHAR = '0';
export const TIME_MINUTES_ZERO = '00';

// Date format constants for date-fns
// 'PP' outputs: 'Apr 29, 2026' (short localized date)
export const DATE_FORMAT_SHORT = 'PP';
// 'PPP' outputs: 'April 29th, 2026' (long localized date)
export const DATE_FORMAT_LONG = 'PPP';
// Full date format outputs: 'Monday, April 29, 2026' (weekday, month, day, year)
export const DATE_FORMAT_FULL = 'PPPP';

// React Query cache configuration (in milliseconds)
export const STALE_TIME_AVAILABILITY_SLOTS = 1000 * 60 * 5; // 5 minutes
